import React from 'react';
import '../styles.css';
import activeIcon from "../icons/todo-active.png";
import sendIcon from "../icons/send.png";
import * as TodoUtil from '../../helpers/TodoUtil';
import { Collapsible } from './Collapsible.js';
import * as DatabaseHelper from '../../helpers/Database';
import { TODO_STATUS } from './TODOList';
let _ = require('lodash');

// NOTE: Make sure this matches inReplyTo on vivabot side too
export const TODO_INREPLYTO = {
	DataEntry: 'dataEntry', // Show up in Data Entry dash. These are the usual data entry TODOs detected by bot.
	DataEntryFood: 'dataEntry-food', // Show up in Data Entry dash. These are the usual data entry TODOs detected by bot for food only.
	Coach: 'coach', // Show up in Coach Dash, EXCEPT during Quiet Hours Mode. During QHM, they go to Data Entry Dash instead.
	DataEntryManual: 'dataEntry-manual', // SHow up in Data Entry dash. These are TODOs manually forwarded to Data Entry people by Coach.
	CoachArchived: 'coach-archived' // Always show up in Coach Dash, even in Quiet Hours Mode. These are TODOs that get forwarded to Coach Dash by Data Entry people during QHM.
}

const TODO_WAIT_TIMER = 3000; // NOTE: Make sure this matches the same-named const on viva-bot

// ========= POPUP =============

class RecurrencePicker extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			ClientID: '',
			Todo: '',
			RepeatDay: 'None',
			RepeatHour: '00',
			RepeatMinute: '00'
		};

		this.instanceDone = this.instanceDone.bind(this);
		this.foreverDone = this.foreverDone.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.notificationTimer = null;
	}

	instanceDone() {
		this.props.instance();
	}

	foreverDone() {
		this.props.forever();
	}

	handleCancel() {
		this.props.cancel();
	}

	render() {
		return (
			<div className='popup'>
				<div className='popupInner'>
					<div className="slightPaddingAllSides">
						<p>Done with this instance or forever?</p>
						<button className="slightRightMargin" onClick={this.instanceDone}>Delete Instance</button>
						<button className="slightRightMargin" onClick={this.foreverDone}>Delete Forever</button>
						<button className="slightRightMargin" onClick={this.handleCancel}>Cancel</button>
					</div>
				</div>
			</div>
		);
	}
}

// ========= TODO =============

export class TODO extends React.Component {
	constructor(props) {
		super(props);
		this.totalImportance = 'normal';
		this.oldPropsId;
		this.isMIA = false;

		this.state = {
			name: '',
			showRecurrencePicker: false,
			todo: '',
			p0note: null
		};
		this.toggleStatus = this.toggleStatus.bind(this);
		this.showClientUserPanel = this.showClientUserPanel.bind(this);
		this.findTODODescription = this.findTODODescription.bind(this);
	}

	async componentWillMount() {
		// find the client name based on client ID
		let userSubscription = this.props.migratedUserStatus ?
			this.props.migratedUserStatus :
			await DatabaseHelper.getFirebaseEntryAsync(`userSubscriptions/${this.props.id}`);

		let name = userSubscription ? userSubscription.name : 'Unknown';

		let charExtractor = /\D/g;
		if (_.isEmpty(name) || name.match(charExtractor) === null || name.match(charExtractor)[0] === " ")
			name = "Unknown name";

		this.userName = name;
		this.setState({ name: name, p0note: userSubscription ? userSubscription.p0note : null });
		//this.props.playNotifySoundIfTodosStillRed();
	}

	componentDidUpdate(prevProps, prevState) {

	}

	async toggleStatus(e) {
		this.onClick(e);
		if (this.props.readOnlyMode) {
			return;
		}

		let todoItemPath = e.target.name;
		this.setState({ todo: todoItemPath });

		// get recurrence value of TODO
		DatabaseHelper.doOnReadingFirebaseEntry(`todos/${this.props.id}/${todoItemPath}`, (snapshot) => {
			let thisTodoItem = snapshot.val();
			if (!thisTodoItem) {
				return;
			}
			let thisRecurrence = thisTodoItem.recurrence;

			// delete if not recurring, else ask if done with instance or forever
			if (thisRecurrence.includes("None")) {
				let inReplyTo = thisTodoItem.inReplyTo;
				TodoUtil.removeTodoItem(this.props.id + "/" + todoItemPath);
			}
			else {
				this.setState({ showRecurrencePicker: !this.state.showRecurrencePicker });
			}

			if (this.props.onToggleStatus) {
				this.props.onToggleStatus(todoItemPath);
			}
		});
	}

	async deleteInstance() {
		// close popup
		this.setState({ showRecurrencePicker: !this.state.showRecurrencePicker });

		// get recurrence, description, importance of TODO
		let existingTodo = await DatabaseHelper.getFirebaseEntryAsync('todos/' + this.props.id + "/" + this.state.todo);
		let recur = existingTodo.recurrence;

		// extract hour and minute from recurrence
		var hour = recur.substring(recur.lastIndexOf("-") + 1, recur.lastIndexOf(":"));
		var minute = recur.substring(recur.lastIndexOf(":") + 1);

		// build todos-archive path based on recurrence
		if (recur.includes("Daily")) {
			var path = "todos-archive/" + hour + "/" + minute + "/" + this.props.id + "/" + this.state.todo;
			TodoUtil.addNewTodoItemWithNoFBID(path, existingTodo);
		}
		else { // weekly recurrence
			var day = recur.substring(recur.indexOf("-") + 1, recur.lastIndexOf("-"));
			var path = "todos-archive/weekly/" + day + "/" + hour + "/" + minute + "/" + this.props.id + "/" + this.state.todo;
			TodoUtil.addNewTodoItemWithNoFBID(path, existingTodo);
		}

		// delete the instance in todos
		TodoUtil.removeTodoItem(this.props.id + "/" + this.state.todo);
	}

	async deleteForever() {
		// close popup
		this.setState({ showRecurrencePicker: !this.state.showRecurrencePicker });

		// delete the todo altogether
		TodoUtil.removeTodoItem(this.props.id + "/" + this.state.todo);
	}

	cancelPopup() {
		this.setState({ showRecurrencePicker: !this.state.showRecurrencePicker });
	}

	showClientUserPanel(e) {
		this.onClick(e);
		if (this.props.readOnlyMode) {
			return;
		}

		this.props.clickTODO(this.props.id, {
			todoId: e.target.dataset.todoid,
			inReplyTo: e.target.dataset.inreplyto,
			todoShorthand: e.target.dataset.shorthand,
			userId: e.target.dataset.userid,
			todoDataType: e.target.dataset.datatype
		});
	}

	editTodo(e) {
		this.onClick(e);
		if (this.props.readOnlyMode) {
			return;
		}

		let pathVal = _.get(e.target.name);
		if (!pathVal) {
			pathVal = e.target.dataset.name;
		}
		this.props.onEditTodo(`${this.props.id}/${pathVal}`);
	}

	onClick = (e) => {
		if (!this.props.onClick) {
			return;
		}

		let pathVal = e.target.name;
		if (!pathVal) {
			pathVal = e.target.dataset.name;
		}
		this.props.onClick(`${this.props.id}/${pathVal}`);
	}

	toggleDataEntryMode = (e) => {
		let pathVal = e.target.name;
		let isChecklist = pathVal.split('/')[0] === 'checklist';
		if (isChecklist) {
			TodoUtil.removeTodoItem(this.props.id + "/" + pathVal); // Just delete it. Almost all the time, this is accidental click on the Send button.
			return;
		}

		let inreplyto = e.target.dataset.inreplyto;
		if (inreplyto === undefined || inreplyto === null) {
			inreplyto = TODO_INREPLYTO.CoachArchived;
		}

		if (this.props.coachingQuietHoursMode) {

			DatabaseHelper.setFirebaseEntry(
				`todos/${this.props.id}/${pathVal}/inReplyTo`,
				inreplyto === TODO_INREPLYTO.CoachArchived ? TODO_INREPLYTO.DataEntryManual : TODO_INREPLYTO.CoachArchived
			);
		} else {
			DatabaseHelper.setFirebaseEntry(
				`todos/${this.props.id}/${pathVal}/inReplyTo`,
				inreplyto === TODO_INREPLYTO.DataEntry || inreplyto === TODO_INREPLYTO.DataEntryManual ? TODO_INREPLYTO.Coach : TODO_INREPLYTO.DataEntryManual
			);
		}

		if (this.props.onToggleStatus) {
			this.props.onToggleStatus(pathVal);
		}

		if (inreplyto === TODO_INREPLYTO.DataEntry || inreplyto === TODO_INREPLYTO.DataEntryManual || inreplyto === TODO_INREPLYTO.DataEntryFood) {

		}
	}


	isHighImportance(msgType, inner) {
		//return msgType === "newMessage" || msgType === "request" || inner.importance === "high";
		return !_.get(inner, 'dataEntryContent.needsHelp', false);
	}

	toggleIfGoingFromHighToNormal(clientImportance, propsId, FbPath) {
		if (this.props.onToggleStatus && clientImportance[propsId] != 'high') {
			this.props.onToggleStatus(FbPath);
		}
	}

	findTODODescription(propsId) {
		var FbPath = '';
		var elements = [];
		var itemImportance = 'normal';
		var clientImportance = [];	// have to store state per client because no idea why storing newID to oldID var causes oldID to always === newID
		var clientMIA = [];
		let newtotalImportance = this.totalImportance;

		for (let msgType in this.props.todo) {
			let FbId = this.props.todo[msgType];

			for (let id in FbId) {
				// unique key per todo
				FbPath = msgType + "/" + id;

				let inner = FbId[id];
				if (!this.props.fullViewMode) {
					if (this.props.dataEntryMode) {
						if (_.isEmpty(inner.inReplyTo) || inner.inReplyTo === TODO_INREPLYTO.CoachArchived) {
							this.toggleIfGoingFromHighToNormal(clientImportance, propsId, FbPath);
							continue;
						}
					} else if (inner.inReplyTo === TODO_INREPLYTO.DataEntry || inner.inReplyTo === TODO_INREPLYTO.DataEntryManual || inner.inReplyTo === TODO_INREPLYTO.DataEntryFood) {
						this.toggleIfGoingFromHighToNormal(clientImportance, propsId, FbPath);
						continue;
					}
				}

				let createdTimestampString = inner.createdTimestamp ? TodoUtil.getTimestampString(inner.createdTimestamp) : null;
				let createdTimestampHtml = this.props.readOnlyMode ? <span /> : (
					createdTimestampString ?
						(<div data-name={FbPath}><small data-name={FbPath}>[Created {createdTimestampString}]</small></div>) : (<span />)
				);
				let updatedTimestampString = inner.updatedTimestamp ? TodoUtil.getTimestampString(inner.updatedTimestamp) : null;
				let updatedSinceLastCheckedNotes = false;
				if (inner.updatedTimestamp && inner.lastAdminToEdit != this.props.adminId) {
					let adminLastCheckedNotes = TodoUtil.getAdminLastCheckedNotesTime(inner, this.props.adminId);
					if (!adminLastCheckedNotes || inner.updatedTimestamp > adminLastCheckedNotes) {
						updatedSinceLastCheckedNotes = true;
					}
				}

				let updatedTimestampHtml = this.props.readOnlyMode ? <span /> : (
					updatedTimestampString ? (
						<div data-name={FbPath} style={{ backgroundColor: updatedSinceLastCheckedNotes ? 'yellow' : 'white' }}>
							<small data-name={FbPath}>[Updated {updatedTimestampString}]</small>
						</div>
					) : (<span />)
				);

				if (this.isHighImportance(msgType, inner)) {
					itemImportance = 'high';
					if (this.totalImportance === 'normal') {
						if (this.props.dataEntryMode) {
							this.props.playNotifySound();
							this.props.makeFaviconRed('data');
						} else {
							clearTimeout(this.notificationTimer);
							this.foodInputTimer = setTimeout(() => { // FS throttles their API calls, so wait until after user finishes typing to call their API. 
								this.props.playNotifySoundIfCoachTodoStillRed(this.props.id); // Wait 2 seconds because some 'coach' TODOs may get converted to TODO_INREPLYTO.DataEntry ones after asyn search results return
								this.props.makeFaviconRed('coach');
							}, TODO_WAIT_TIMER);
						}
					}
					newtotalImportance = 'high';
					clientImportance[propsId] = 'high';
				} else {
					itemImportance = inner.importance === 'medium' ? 'medium' : 'normal';
					if (clientImportance[propsId] != 'high' && clientImportance[propsId] != 'medium') {
						newtotalImportance = itemImportance;
						clientImportance[propsId] = itemImportance === 'medium' ? 'medium' : 'normal';
					}

					if (msgType === "MIA") {
						this.isMIA = true;
						clientMIA[propsId] = true;
					} else {
						if (!clientMIA[propsId])
							this.isMIA = false;
					}
				}

				let sendButton = inner.isV2 ? <span /> :
					<div style={{ marginTop: '10px', marginLeft: '5px' }}>
						<img name={FbPath} data-inreplyto={inner.inReplyTo} data-containsquestion={inner.containsQuestion}
							src={sendIcon} onClick={this.toggleDataEntryMode} data-fullmsg={inner.fullMsg} data-msgtype={msgType} />
					</div>;

				let editEmoji = inner.notes ? '📝' : '✏️';
				let editTodoButton = this.props.readOnlyMode ? <span /> : (
					<input name={FbPath} data-name={FbPath} style={{ backgroundColor: 'rgba(0, 0, 0, 0)', border: 'none' }}
						type='submit' value={editEmoji}
						onClick={this.editTodo.bind(this)}
					/>
				);
				let editHandlerPicker =
					<div className='pl-0 border-0 float-left clickable' style={{ float: 'left', textAlign: 'center' }}>
						<div>{editTodoButton}</div>
					</div>;

				let status = inner.status ? inner.status : TODO_STATUS.NotStarted.name;
				let statusObj = TODO_STATUS[status];
				let statusText = statusObj ?
					(<small data-name={FbPath} style={{ color: TODO_STATUS[status].color }}><b data-name={FbPath}>{status}</b></small>) :
					(<small data-name={FbPath} style={{ color: 'white' }}><b data-name={FbPath}>{status}</b></small>);
				let todoCheck = this.props.readOnlyMode || inner.isV2 ? <span /> :
					<img name={FbPath} data-name={FbPath} className="todoCheck" src={activeIcon} onClick={this.toggleStatus} />;

				let todoHandlerPicker =
					<div>
						{todoCheck}
						{sendButton}
					</div>;

				// add to array
				if (itemImportance === "high") {
					if (!inner.recurrence.includes("None") || msgType === "retention" || msgType === "MIA" || msgType === "offTrack" || msgType === "request") {
						elements.unshift(
							<div className={`todoBoxBase todoBoxFAQ clickable ${msgType}`}>
								{editHandlerPicker}
								<div key={FbPath} className="leftRightOnSameLine">
									<p className="noMargin heavyFont wrapText highImportanceText" onClick={this.showClientUserPanel}
										data-userId={propsId} data-shorthand={inner.shorthand} data-datatype={inner.dataType}
										name={FbPath} data-name={FbPath} data-inreplyto={inner.inReplyTo}
									>
										{updatedTimestampHtml}
										{inner.description}
										<span data-name={FbPath}>
											<img className="imgRepeat" src="https://cdn2.iconfinder.com/data/icons/woothemes/PNG/arrow_cycle.png" />
										</span>
										<div data-name={FbPath}> {statusText} {createdTimestampHtml} </div>
									</p>
									{todoHandlerPicker}
								</div>
							</div>
						);
					}
					else {
						if (inner.inReplyTo === TODO_INREPLYTO.DataEntry || inner.inReplyTo === TODO_INREPLYTO.DataEntryFood) {
							const todoContainerClasses = _.get(inner, 'dataEntryContent.needsHelp') ?
								`todoBoxBase todoBoxDataEntry-Skipped clickable ${msgType}` :
								`todoBoxBase todoBoxDataEntry clickable ${msgType}`;

							const todoContentClasses = _.get(inner, 'dataEntryContent.needsHelp') ?
							"noMargin heavyFont wrapText" :
								"noMargin heavyFont wrapText highImportanceText";
							elements.unshift(
								<div className={todoContainerClasses} >
									{editHandlerPicker}
									<div key={FbPath} className="leftRightOnSameLine">
										<p className={todoContentClasses} data-inreplyto={inner.inReplyTo} data-todoId={id}
											onClick={this.showClientUserPanel} data-userId={propsId} data-shorthand={inner.shorthand} data-containsquestion={inner.containsQuestion}
											data-datatype={inner.dataType} name={FbPath} data-name={FbPath}
										>
											{updatedTimestampHtml}
											{inner.description}
											<div data-name={FbPath}> {statusText} {createdTimestampHtml} </div>
										</p>
										{todoHandlerPicker}
									</div>
								</div>
							);
						}
						else {
							elements.unshift(
								<div className={`todoBoxBase todoBoxCoach clickable ${msgType}`}>
									{editHandlerPicker}
									<div key={FbPath} className="leftRightOnSameLine">
										<p className="noMargin heavyFont wrapText highImportanceText" onClick={this.showClientUserPanel} data-userId={propsId}
											data-shorthand={inner.shorthand} data-datatype={inner.dataType} name={FbPath} data-name={FbPath} data-inreplyto={inner.inReplyTo}
										>
											{updatedTimestampHtml}
											{inner.description}
											<div data-name={FbPath}> {statusText} {createdTimestampHtml} </div>
										</p>
										{todoHandlerPicker}
									</div>
								</div>
							);
						}
					}
				}
				else {
					let mediumImportanceTextClass = inner.importance === 'medium' ? 'mediumImportanceText' : '';
					if (!inner.recurrence.includes("None") || msgType === "retention" || msgType === "MIA" || msgType === "offTrack") {
						if (msgType === "manual") {
							elements.push(
								<div className={`todoBoxBase todoBoxCoach clickable ${msgType} ${mediumImportanceTextClass}`}>
									{editHandlerPicker}
									<div key={FbPath} className="leftRightOnSameLine">
										<p className="noMargin heavyFont wrapText" onClick={this.showClientUserPanel} data-userId={propsId}
											data-shorthand={inner.shorthand} data-datatype={inner.dataType} name={FbPath} data-name={FbPath} data-inreplyto={inner.inReplyTo}
										>
											{updatedTimestampHtml}
											{inner.description}
											<span data-name={FbPath}>
												<img className="imgRepeat" src="https://cdn2.iconfinder.com/data/icons/woothemes/PNG/arrow_cycle.png" />
											</span>
											<div data-name={FbPath}> {statusText} {createdTimestampHtml} </div>
										</p>
										{todoHandlerPicker}
									</div>
								</div>
							);
						}
						else {
							elements.push(
								<div className={`todoBoxBase todoBoxFAQ clickable ${msgType} ${mediumImportanceTextClass}`}>
									{editHandlerPicker}
									<div key={FbPath} className="leftRightOnSameLine">
										<p className="noMargin heavyFont wrapText" onClick={this.showClientUserPanel} data-userId={propsId}
											data-shorthand={inner.shorthand} data-datatype={inner.dataType} name={FbPath} data-name={FbPath} data-inreplyto={inner.inReplyTo}
										>
											{updatedTimestampHtml}
											{inner.description}
											<span data-name={FbPath}>
												<img className="imgRepeat" src="https://cdn2.iconfinder.com/data/icons/woothemes/PNG/arrow_cycle.png" />
											</span>
											<div data-name={FbPath}> {statusText} {createdTimestampHtml} </div>
										</p>
										{todoHandlerPicker}
									</div>
								</div>
							);
						}
					}
					else {
						elements.push(
							<div className={`todoBoxBase todoBoxCoach clickable ${msgType} ${mediumImportanceTextClass}`}>
								{editHandlerPicker}
								<div key={FbPath} className="leftRightOnSameLine">
									<p className="noMargin heavyFont wrapText" onClick={this.showClientUserPanel} data-userId={propsId} data-inreplyto={inner.inReplyTo}
										data-shorthand={inner.shorthand} data-datatype={inner.dataType} name={FbPath} data-name={FbPath}>
										{updatedTimestampHtml}
										{inner.description}
										<div data-name={FbPath}> {statusText} {createdTimestampHtml} </div>
									</p>
									{todoHandlerPicker}
								</div>
							</div>
						);
					}
				}
			}
		}

		// return list of TODOs for client
		if (_.isEmpty(elements)) { // Can happen if we're on the Coach dash and this user only has data entry TODOs or vice versa
			newtotalImportance = 'normal';
		}
		this.totalImportance = newtotalImportance;
		return elements;
	}

	render() {
		let detail = this.findTODODescription(this.props.id);
		if (_.isEmpty(detail)) {
			return <span />;
		}

		let recurPicker = (
			this.state.showRecurrencePicker ?
				<RecurrencePicker
					instance={this.deleteInstance.bind(this)}
					forever={this.deleteForever.bind(this)}
					cancel={this.cancelPopup.bind(this)}
				/>
				: null
		);

		const timePassedNote = this.props.todo.timePassed ? '(' + Math.round(this.props.todo.timePassed/60000) + ' min ago)' : '';
		let todoTitle = `${this.state.name} ${timePassedNote}`;
		if (this.totalImportance === 'normal') {
			if (this.isMIA) {
				return (
					<div>
						<Collapsible key={this.props.id} className="accordian_outer_normalImportance_MIA" openedClassName="accordian_outer_normalImportance"
							trigger={todoTitle} transitionTime={100} open={this.props.readOnlyMode}
						>
							{detail}
						</Collapsible>
						{recurPicker}
					</div>
				);
			} else {
				return (
					<div>
						<Collapsible key={this.props.id} className="accordian_outer_normalImportance" openedClassName="accordian_outer_normalImportance"
							trigger={todoTitle} transitionTime={100} open={this.props.readOnlyMode}
						>
							{detail}
						</Collapsible>
						{recurPicker}
					</div>
				);
			}
		} else if (this.totalImportance === 'medium') {
			return (
				<div>
					<Collapsible key={this.props.id} className="accordian_outer_mediumImportance" openedClassName="accordian_outer_normalImportance"
						trigger={todoTitle} transitionTime={100} open={this.props.readOnlyMode}
					>
						{detail}
					</Collapsible>
					{recurPicker}
				</div>
			);
		} else {
			return (
				<div>
					<Collapsible key={this.props.id} style={{ color: 'red' }} className="accordian_outer_highImportance" openedClassName="accordian_outer_normalImportance"
						trigger={todoTitle} transitionTime={100} open={this.props.readOnlyMode}
					>
						{detail}
					</Collapsible>
					{recurPicker}
				</div>
			);
		}
	}
}


// WEBPACK FOOTER //
// ./src/main/todos/TODO.js